import request from '@/utils/request'
// import _ from 'lodash'
/* eslint-disable */
// 增加多余的参数比如：targetLoadingDom
function otherParams(params) {
  return params ['targetLoadingDom'] = '.app-main'
}
export function getReportMetaData(params) {
  otherParams(params);
  return request({
    url: '/report/meta/' + params.code,
    method: 'get',
    params: params
  })
}

export function getReportData(url, params) {
  otherParams(params);
  return request({
    url: url,
    method: 'post',
    data: params
  })
}
export function ajaxSendBatch(params) {
  const url = params.url|| params.path
  const type = params.ajaxType
  otherParams(params.params);
  if(_.toLower(type) === 'post') {
    return request({
      url: url,
      method: type,
      data: params.params
    })
  } else  {
    return request({
      url: url,
      method: type,
      params: params.params
    })
  }
}

export function ajaxSend(params) {
  const url = params.url|| params.path
  const type = params.ajaxType
  otherParams(params.params);
  if(_.toLower(type) === 'post'){
    return request({
      url: url,
      method: type,
      data: params.params
    })
  } else {
    return request({
      url: url,
      method: type,
      params: params.params
    })
  }

}
export function exportSend(url, ajaxType, params) {
  let type = ''
  switch (ajaxType) {
    case 'post':
      type = 'data'
      break
    case 'get':
      type = 'params'
      break
  }
  otherParams(params);
  return request({
    url: url,
    method: ajaxType,
    [type]: params,
    responseType: 'blob'
  })
}


// 获取权限管理的请求
export function getAuthorityData(url, method) {
  return request({
    url: url,
    method: method
  })
}

// 权限管理新增保存
export function AuthorityAdd(url, method, params) {
  return request({
    url: url,
    method: method,
    data: params
  })
}

// 编辑权限查询保存的权限列表
export function queryAuthority(url, method) {
  return request({
    url: url,
    method: method
  })
}

// 获取顾客详情的请求
export function getCustomerDetails(url, method) {
  return request({
    url: url,
    method: method
  })
}

// 点击查询订单详情
export function queryOrderDetail(url, method, params) {
  return request({
    url: url,
    method: method,
    params: params
  })
}

// 获取商品详情
export function queryGoodDetail(url, method, params) {
  return request({
    url: url,
    method: method,
    data: params
  })
}

export function getInfoForExport(url, params) {
  return request({
    url: url,
    method: 'post',
    data: params
  })
}
export function exportForYH(url, xmlData, token) {
  return request({
    url: url + token,
    method: 'post',
    responseType: 'blob',
    data: {
      xmlData
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/report.js